<template>

  <div class='chart-wrapper simpleStackedBar'>

  </div>

</template>

<script>

	import * as d3 from 'd3';

	import simpleStackedBar from "@/charts/simpleStackedBar";

//template for reference
	const fakedata = 	[{
						'value': 10,
						'label': "First",
						'color': '#aa1c2f'
					},
					{
						'value': 32,
						'label': "Second",
						'color': '#4a2baa'
					},
					{
						'value': 32,
						'label': "Third",
						'color': '#18aa0e'
					}]

	export default {
		name: "SimpleStackedBar",
		props: ["chartdata", "maxVal"],
		mounted() {
			new simpleStackedBar({
				bindTo: d3.select(this.$el),
				maximum_value: this.maxVal, // use this compare to max value. Maybe leader's score?
				data: this.chartdata,
			});
		}

	}

</script>

<style lang="less" scoped>

  .chart-wrapper {
    padding: 15px;
    max-width: 600px;
    margin: 0 auto;
  }



</style>
